export enum StorageAuth {
    Session = 'session'
}
